import React from 'react';

interface ProductScreenshotProps {
  imageSrc: string;
  imageAlt: string;
  productName: string;
  color: 'primary' | 'accent';
  urlLabel?: string;
  className?: string;
  loading?: 'lazy' | 'eager';
}

const ProductScreenshot: React.FC<ProductScreenshotProps> = ({
  imageSrc,
  imageAlt,
  productName,
  color,
  urlLabel = 'app.cimmple.com',
  className = '',
  loading = 'lazy',
}) => {
  const isPrimary = color === 'primary';

  return (
    <div
      className={`rounded-2xl border bg-white dark:bg-dark-900 shadow-2xl overflow-hidden ${
        isPrimary
          ? 'border-slate-200 dark:border-dark-700 shadow-slate-900/10 dark:shadow-black/40'
          : 'border-accent-400/40 dark:border-accent-500/50 shadow-accent-500/10 dark:shadow-black/40'
      } ${className}`}
    >
      <div
        className={`flex items-center gap-2 px-4 py-3 border-b ${
          isPrimary
            ? 'border-slate-200 dark:border-dark-700 bg-slate-50 dark:bg-dark-800/80'
            : 'border-accent-200/60 dark:border-accent-500/20 bg-gradient-to-r from-accent-50 to-white dark:from-accent-500/10 dark:to-dark-900'
        }`}
      >
        <div className="flex gap-1.5">
          <span className="w-3 h-3 rounded-full bg-red-400" />
          <span className="w-3 h-3 rounded-full bg-amber-400" />
          <span className="w-3 h-3 rounded-full bg-green-400" />
        </div>
        <div className="flex-1 flex justify-center">
          <span className="px-3 py-1 rounded-md bg-white dark:bg-dark-900 border border-slate-200 dark:border-dark-600 text-xs text-slate-500 dark:text-dark-400">
            {urlLabel}
          </span>
        </div>
        <span
          className={`text-xs font-semibold whitespace-nowrap ${
            isPrimary ? 'text-primary-600 dark:text-primary-400' : 'text-accent-600 dark:text-accent-400'
          }`}
        >
          {productName}
        </span>
      </div>
      <img src={imageSrc} alt={imageAlt} className="w-full h-auto block" loading={loading} />
    </div>
  );
};

export default ProductScreenshot;
